import React, { useEffect, useState } from "react";
import api from "../../api";

export default function PlaylistPage() {
  const [name, setName] = useState("");
  const [songs, setSongs] = useState([]);
  const [playlistList, setPlaylistList] = useState([]);
  const [allMedia, setAllMedia] = useState([]);

  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [playlistSongs, setPlaylistSongs] = useState([]);

  // Load initial data
  useEffect(() => {
    loadMedia();
    loadPlaylists();
  }, []);

  const loadMedia = async () => {
    const res = await api.get("/api/media");
    setAllMedia(res.data);
  };

  const loadPlaylists = async () => {
    const res = await api.get("/api/playlist/list");
    setPlaylistList(res.data);
  };

  const createPlaylist = async () => {
    if (!name.trim()) return alert("Playlist name required!");

    await api.post("/api/playlist/create", { name, songs });
    setName("");
    setSongs([]);

    loadPlaylists();
    alert("Playlist Created!");
  };

  const toggleSongNew = (songId) => {
    setSongs((prev) =>
      prev.includes(songId) ? prev.filter((id) => id !== songId) : [...prev, songId]
    );
  };

  const toggleSongExisting = (songId) => {
    setPlaylistSongs((prev) =>
      prev.includes(songId) ? prev.filter((id) => id !== songId) : [...prev, songId]
    );
  };

  const saveSongsToPlaylist = async () => {
    if (!selectedPlaylist) return;

    for (const songId of playlistSongs) {
      await api.put(`/api/playlist/${selectedPlaylist._id}/add`, { songId });
    }

    setShowAddModal(false);
    loadPlaylists();
  };

  const removeSong = async (playlistId, songId) => {
    if (!window.confirm("Remove this song from playlist?")) return;

    await api.put(`/api/playlist/${playlistId}/remove`, { songId });

    loadPlaylists();
  };

  return (
    <div className="p-6">

      {/* HEADER */}
      <h1 className="text-3xl font-bold mb-3 text-center"> Manage Playlists</h1>
      <p className="text-gray-500 mb-6 text-center">
        Create playlists and manage songs inside them.
      </p>

      {/* CREATE PLAYLIST */}
      <div className="bg-white p-6 rounded-xl shadow-md border mb-10">
        <h2 className="text-xl font-semibold mb-4">Create New Playlist</h2>

        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Playlist Name"
          className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-500 mb-4"
        />

        <h3 className="font-semibold text-gray-700 mb-2">Select Songs</h3>

        <div className="max-h-64 overflow-y-auto border rounded-lg p-3 space-y-2 bg-gray-50">
          {allMedia.map((media) => (
            <label key={media._id} className="flex items-center gap-3">
              <input
                type="checkbox"
                checked={songs.includes(media._id)}
                onChange={() => toggleSongNew(media._id)}
              />
              <span className="text-gray-800">{media.title}</span>
            </label>
          ))}
        </div>

        <button
          onClick={createPlaylist}
          className="mt-5 bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-2 rounded-lg shadow"
        >
          Create Playlist
        </button>
      </div>

      {/* LIST OF PLAYLISTS */}
      <h2 className="text-2xl font-semibold mb-4">All Playlists</h2>

      <div className="grid gap-6 lg:grid-cols-2">
        {playlistList.map((pl) => (
          <div
            key={pl._id}
            className="bg-white p-6 rounded-xl shadow border hover:shadow-lg transition"
          >
            <div className="flex justify-between items-center">
              <h3 className="text-xl font-bold">{pl.name}</h3>
              <span className="bg-green-100 text-green-700 text-xs px-2 py-1 rounded">
                {pl.songs.length} Songs
              </span>
            </div>

            {/* SONGS */}
            <ul className="mt-3 space-y-2">
              {pl.songs.map((s) => (
                <li
                  key={s._id}
                  className="flex justify-between items-center bg-gray-50 p-2 rounded"
                >
                  <span> {s.title}</span>

                  <button
                    onClick={() => removeSong(pl._id, s._id)}
                    className="text-red-600 hover:text-red-800 text-sm"
                  >
                    ✕ Remove
                  </button>
                </li>
              ))}
            </ul>

            {/* ADD MORE SONGS */}
            <button
              onClick={() => {
                setSelectedPlaylist(pl);
                setPlaylistSongs(pl.songs.map((s) => s._id));
                setShowAddModal(true);
              }}
              className="mt-3 text-green-600 hover:underline font-medium "
            >
               Add / Remove Songs
            </button>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-xl p-6 w-96 max-h-[90vh] overflow-y-auto shadow-xl border">

            <h2 className="text-xl font-bold mb-4">
              Edit Playlist — {selectedPlaylist?.name}
            </h2>

            <div className="space-y-2">
              {allMedia.map((song) => (
                <label key={song._id} className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    checked={playlistSongs.includes(song._id)}
                    onChange={() => toggleSongExisting(song._id)}
                  />
                  <span>{song.title}</span>
                </label>
              ))}
            </div>

            <div className="mt-5 flex gap-3">
              <button
                onClick={saveSongsToPlaylist}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
              >
                Save Changes
              </button>

              <button
                onClick={() => setShowAddModal(false)}
                className="text-red-600 font-semibold"
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
}
